// Question variant types
export const QUESTION_VARIANTS = {
  PREP: 'prep',
  CUSTOMER_FORM: 'customer-form',
}

// Question types supported in customer-form variant
// Only single/multi select and slider questions are supported
export const CUSTOMER_FORM_SUPPORTED_TYPES = ['single', 'multi', 'slider']

